"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(theme) {
  return {
    formControl: {
      margin: theme.spacing(1)
    },
    fullWidth: {
      // TODO: bug in material ui?
      width: "calc(100% - ".concat(theme.spacing(2), "px)")
    },
    noMarginBottom: {
      marginBottom: 0
    }
  };
};

var FormControl = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(FormControl, _React$PureComponent);

  var _super = _createSuper(FormControl);

  function FormControl() {
    (0, _classCallCheck2.default)(this, FormControl);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(FormControl, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          fullWidth = _this$props.fullWidth,
          children = _this$props.children,
          classes = _this$props.classes,
          marginBottom = _this$props.marginBottom;
      var fullWidthClassName = fullWidth ? classes.fullWidth : '';
      var noMarginBottomClassName = marginBottom === false ? classes.noMarginBottom : '';
      return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        fullWidth: fullWidth,
        className: "".concat(classes.formControl, " ").concat(fullWidthClassName, " ").concat(noMarginBottomClassName)
      }, children);
    }
  }]);
  return FormControl;
}(_react.default.PureComponent);

var _default = (0, _withStyles.default)(styles)(FormControl);

exports.default = _default;